// Labels for report period keys returned by the API (Vietnam calendar dates).
// Keys: day 'YYYY-MM-DD', week 'YYYY-MM-DD' (its Monday), month 'YYYY-MM',
// quarter 'YYYY-Qn', year 'YYYY'. Pure string/UTC math so the browser timezone
// never shifts a label.
export const DIMENSION_LABELS = {
  day: 'Ngày',
  week: 'Tuần',
  month: 'Tháng',
  quarter: 'Quý',
  year: 'Năm',
};

const parts = (ymd) => ymd.split('-').map(Number);
const ddmm = (date) => `${date.getUTCDate()}/${date.getUTCMonth() + 1}`;

export const formatPeriodLabel = (period, dimension) => {
  if (!period) return '';
  if (dimension === 'year') return period;
  if (dimension === 'quarter') {
    const [year, q] = period.split('-Q');
    return `Q${q}/${year}`;
  }
  if (dimension === 'month') {
    const [year, month] = period.split('-');
    return `${month}/${year}`;
  }
  const [y, m, d] = parts(period);
  if (dimension === 'week') {
    const monday = new Date(Date.UTC(y, m - 1, d));
    const sunday = new Date(Date.UTC(y, m - 1, d + 6));
    return `${ddmm(monday)} - ${ddmm(sunday)}`;
  }
  return `${d}/${m}/${y}`;
};
